import React, { useState } from "react";

import InputField from "../../forms/input-field";
import MultipleImagesField from "../../forms/multiple-images-field";
import { Field, useFormikContext } from "formik";
import LoadingSpinner from "../../helper-components/loading-spinner";
import ImagePreviewModal from "../../helper-components/image-preview-modal";
import UploadIcon from "../../../assets/icons/upload-icon";
import { useDispatch } from "react-redux";
import { imageUploadAction } from "../../../redux/actions/general-action";
import { url } from "../../../redux/config";

const StoreMapsPhotos = ({ disabled = false }) => {
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  const handleDeleteImage = (index) => {
    const updatedImages = values.shop_images.filter((_, i) => i !== index);
    setFieldValue("shop_images", updatedImages);
  };

  const [loading, setloading] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);

  const handleVideoChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setVideoLoading(true);
    dispatch(
      imageUploadAction(
        file,
        (data) => {
          setFieldValue("store_360_video", `${url}/image/${data}`);
          setVideoLoading(false);
        },
        () => setVideoLoading(false)
      )
    );
  };

  return (
    <>
      <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 mt-5">
        <InputField
          isDisabled={disabled}
          // isRequired={true}
          type="text"
          name="store_latitude"
          placeholder="Enter Store Latitude "
          label="Store Latitude"
          labelWidth="12.8rem"
        />
        <InputField
          isDisabled={disabled}
          // isRequired={true}
          type="text"
          name="store_longitude"
          placeholder="Enter Store Longitude"
          label="Store Longitude"
          labelWidth="12.8rem"
        />
        <MultipleImagesField
          isDisabled={disabled}
          // isRequired={true}
          setloading={setloading}
        />
        <div className="mt-2">
          <label
            htmlFor="store_360_video"
            className="flex items-center whitespace-nowrap text-sm fw_400 text-secondary w-full"
          >
            <span style={{ minWidth: "12.8rem" }} className="flex text-label-color">
              360° Video
            </span>
            <div
              style={{ height: "2.9rem" }}
              className="inputField_border flex items-center gap-3 w-full py-10 text-667085"
            >
              <UploadIcon fill="var(--placeholder-color)" />
              {values.store_360_video ? "Replace Video" : "Upload Video"}
            </div>
          </label>
          <Field>
            {({ field }) => (
              <input
                disabled={disabled}
                id="store_360_video"
                type="file"
                accept="video/*"
                onChange={(event) => {
                  handleVideoChange(event);
                  field.onChange(event);
                }}
                style={{ display: "none" }}
              />
            )}
          </Field>
          {videoLoading && <LoadingSpinner />}
          {values.store_360_video && !videoLoading && (
            <div className="mt-3">
              <video
                src={values.store_360_video}
                controls
                style={{ maxHeight: "10rem", borderRadius: "0.5rem" }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="px-5 xl:px-10 mt-5 flex flex-wrap gap-10">
        {Array.isArray(values.shop_images) &&
          values.shop_images.map((im, index) => (
            <div
              key={index}
              className="relative group"
              style={{
                width: "fit-content",
              }}
            >
              <img
                src={im}
                alt={`Image ${index}`}
                className="object-cover rounded-lg cursor-pointer bg-EBEBEB"
                style={{ height: "10rem" }}
                onClick={() => setPreviewSrc(im)}
              />
              <button
                type="button"
                onClick={() => handleDeleteImage(index)}
                className="absolute bottom-0 right-0 p-2 bg-F51D00-500 text-white text-xs hover:bg-F51D00-600 transition duration-300 invisible group-hover:visible rounded-t-none rounded-bl-md rounded-br-md"
                style={{ width: "100%" }}
              >
                Delete
              </button>
            </div>
          ))}
        {loading && <LoadingSpinner />}
      </div>
      <ImagePreviewModal
        isOpen={!!previewSrc}
        onClose={() => setPreviewSrc(null)}
        src={previewSrc}
      />
    </>
  );
};

export default StoreMapsPhotos;
